import { Action, readPermissions } from "../../../features/roles";
import { TableName } from '../../../tables'
import { administrationPermissions } from '../../administration'
import { logisticsPermissions } from "../../logistics";
import { purchasesPermissions } from '../../purchases'
import { salesPermissions } from '../../sales'
import { warehousePermissions } from "../../warehouse";

export const managerPermissions = () => readPermissions()
    .concat([
        { tableName: TableName.BRANCHES, actions: [Action.SAVE, Action.REMOVE] },
        { tableName: TableName.EMPLOYEES, actions: [Action.SAVE, Action.REMOVE] },
    ])
    .concat(administrationPermissions())
    .concat(purchasesPermissions())
    .concat(salesPermissions())
    .concat(logisticsPermissions())
    .concat(warehousePermissions())
